import { createAction, handleActions } from 'redux-actions';

import { fromJS } from 'immutable';
import { pender } from 'redux-pender';

//------------------------------------------------------
//api
//------------------------------------------------------
import * as api from 'store/actions/UserApi';

//------------------------------------------------------
//action type
//------------------------------------------------------
const SET_USER_INFO = 'SET_USER_INFO';
const GET_USER_INFO = 'GET_USER_INFO';
const PUT_USER_INFO_CHANGE = 'PUT_USER_INFO_CHANGE';
// const INIT_MY_REVIEW_LIST = 'INIT_MY_REVIEW_LIST';
// const POST_MY_REVIEW_LIST = 'POST_MY_REVIEW_LIST';

//------------------------------------------------------
// action creators
//------------------------------------------------------
export const setUserInfo = createAction(SET_USER_INFO);
export const getUserInfo = createAction(GET_USER_INFO, api.getUserInfo);
export const putUserInfoChange = createAction(PUT_USER_INFO_CHANGE, api.putUserInfoChange);
// export const initMyReviewList = createAction(INIT_MY_REVIEW_LIST);
// export const postMyReviewList = createAction(POST_MY_REVIEW_LIST, api.postMyReviewList);

//------------------------------------------------------
// initial state
//------------------------------------------------------
const initialState = fromJS({
    userInfo:{},
    // myReviewList:[],
    // myReviewPage:0,
});

//------------------------------------------------------
// reducer
//------------------------------------------------------
export default handleActions({
    [SET_USER_INFO] : (state, action) => {
        let data = action.payload;

        return state.set('userInfo', data);
    },
    ...pender({
        type : GET_USER_INFO,
        onSuccess : (state, action) => {
            const {data} = action.payload;

            if (!data.result || !data.data) return state;

            return state.set('userInfo', data.data);
        },
    }),
    ...pender({
        type : PUT_USER_INFO_CHANGE,
        onSuccess : (state, action) => {
            const {data} = action.payload;

            if (!data.result || !data.data) return state;

            return state.set('userInfo', data.data);
        },
    }),



    //
    // [INIT_MY_REVIEW_LIST] : (state, action) => {
    //     return state.set('myReviewList', [])
    //         .set('myReviewPage', 0);
    // },
    // ...pender({
    //     type : POST_MY_REVIEW_LIST,
    //     onSuccess : (state, action) => {
    //         const {data} = action.payload;
    //         if (!data.data) return state;
    //
    //         let myReviewList = state.get('myReviewList') ? state.get('myReviewList') : [];
    //
    //         return state.set('myReviewList', myReviewList.concat(data.data));
    //     },
    // }),
}, initialState)
